import { render } from "./AssessPivBackdate.vue?vue&type=template&id=6c6af86d&scoped=true"
import script from "./AssessPivBackdate.vue?vue&type=script&lang=js"
export * from "./AssessPivBackdate.vue?vue&type=script&lang=js"

import "./AssessPivBackdate.vue?vue&type=style&index=0&id=6c6af86d&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6af86d"]])

export default __exports__